<template>
    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
    >
        <div class="div-with-loading vs-con-loading__container">
            <div id="logoContainer" style="height: 65px; text-align: center; background-color: #1D3662!important; padding: 5px 0px;">
                <a href="/"><img class="logo" src="@/assets/images/tramite/signathor-white.webp" alt="Logo" style="height: 45px; margin-top: 4px;"></a>
            </div>

            <div style="width: 70%; margin: auto; margin-top: 30px;">
                <b-alert v-if="this.$route.params.token" variant="primary" show>
                    <div class="alert-body">
                        <feather-icon
                          icon="InfoIcon"
                          class="mr-50"
                        />
                        Usted está consultando un documento en específico, si desea consultar un documento en general por favor diríjase al
                        <b><a href="https://signathor.com/web_app/documento/verificar/" target="_blank">verificador.</a></b>
                    </div>
                </b-alert>

                <b-alert variant="primary" show>
                    <div class="alert-body">
                        <feather-icon
                          icon="InfoIcon"
                          class="mr-50"
                        />
                        Cargue su archivo PDF para analizar si las firmas electrónicas son válidas.
                    </div>
                </b-alert>

                <p v-if="this.$route.params.token" class="text-center">Cargue su archivo PDF para verificar si el documento es el mismo y si las firmas electrónicas son válidas.</p>
                <div id="profile-pic-demo" class="pt-3">
                    <VueFileAgent
                        class="profile-pic-upload-block"
                        ref="profilePicRef"
                        :multiple="false"
                        :deletable="false"
                        :meta="false"
                        :compact="true"
                        :accept="'.pdf'"
                        :helpText="'Seleccione o arrastre un archivo PDF'"
                        :errorText="{
                          type: 'Solo se permiten archivos PDF',
                        }"
                        v-model="profilePic"
                        @select="onSelect($event)"
                    >
                        <template v-slot:after-inner>
                            <span title="after-inner" class="btn btn-link btn-sm btn-block">{{ filename }}</span>
                        </template >
                    </VueFileAgent>
                </div>
    <!--                <div class="text-center mb-3">-->
    <!--                    <vs-button :disabled="!uploaded" class="mt-3 mb-3" @click="upload()">Verificar</vs-button>-->
    <!--                    <vs-button :disabled="!uploaded" class="ml-auto mt-5 mb-3" color="danger" @click="removePic()">Eliminar</vs-button>-->
    <!--                </div>-->

                <b-alert v-if="message.length>0" :variant="typeMessage" show>
                    <div class="alert-body">
                        <feather-icon
                          :icon="iconMessage"
                          class="mr-50"
                        />
                        <b>{{ this.message }}</b>
                    </div>
                </b-alert>

                <b-row>
                    <b-col v-if="info_verificacion && (info_verificacion.tipo_firma===tipo_firma_electronica || info_verificacion.tipo_firma===tipo_firma_simple) && info_verificacion.firmas.length>0">
                        <b-card title="Resultados">
                            <div class="resultados-list-container">
                                <div style="display: flex; font-weight: bold; padding: 25px 0px; border-bottom: 1px solid #dae1e7;">
                                    <p style="width: 20%; padding-left: 50px; min-width: 80px;">Firmante</p>
                                    <p style="width: 25%; text-align: center; min-width: 30px;">Hash de verificación</p>
                                    <p style="width: 20%; text-align: center; padding-left: 20px; min-width: 70px;">Fecha</p>
                                    <p style="width: 10%; text-align: center; min-width: 40px;">Página</p>
                                    <p style="width: 15%; text-align: center; min-width: 40px;">IP</p>
                                    <p style="width: 10%; text-align: center; min-width: 40px;">Firma</p>
                                </div>
                                <div>
                                    <div v-for="control in info_verificacion.firmas" :key="control.id" style="display: flex; padding: 20px 0px; border-bottom: 1px solid #dae1e7;">
                                        <p style="width: 20%; padding-left: 50px; min-width: 80px; overflow-wrap: break-word;">{{control.firmante.nombres}}</p>
                                        <p style="width: 25%; text-align: center; min-width: 30px; overflow-wrap: break-word;">{{control.firmante.verifying_key}}</p>
                                        <p style="width: 20%; text-align: center; padding-left: 20px; min-width: 70px;">{{control.fecha_procesado}}</p>
                                        <p style="width: 10%; text-align: center; min-width: 40px;">{{control.page}}</p>
                                        <p style="width: 15%; text-align: center; min-width: 40px;">{{control.direccion_ip}}</p>
                                        <p style="width: 10%; text-align: center; min-width: 40px;"><b>Firma válida</b></p>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </b-col>

                    <b-col v-if="info_verificacion && info_verificacion.tipo_firma===tipo_firma_digital && info_verificacion.firmas.length>0">
                        <b-card title="Resultados">
                            <div class="resultados-list-container">
                                <div style="display: flex; font-weight: bold; padding: 25px 0px; border-bottom: 1px solid #dae1e7;">
                                    <p style="width: 25%; padding-left: 50px; min-width: 80px;">Firmante</p>
                                    <p style="width: 15%; text-align: center; min-width: 30px; padding-left: 25px;">Cédula</p>
                                    <p style="width: 20%; text-align: center; padding-left: 25px; min-width: 70px;">Fecha</p>
                                    <p style="width: 25%; text-align: center; min-width: 40px;">Entidad Certificadora</p>
                                    <p style="width: 15%; text-align: center; min-width: 40px;">Firma</p>
                                </div>
                                <div>
                                    <div v-for="firma in info_verificacion.firmas" style="display: flex; padding: 20px 0px; border-bottom: 1px solid #dae1e7;">
                                        <p style="width: 25%; padding-left: 50px; min-width: 80px; overflow-wrap: break-word;">{{firma.nombres}}</p>
                                        <p style="width: 15%; text-align: center; min-width: 30px; overflow-wrap: break-word; padding-left: 25px;">{{firma.cedula}}</p>
                                        <p style="width: 20%; text-align: center; padding-left: 25px; min-width: 70px;">{{firma.generated}}</p>
                                        <p style="width: 25%; text-align: center; min-width: 50px;">{{firma.issuedBy}}</p>
                                        <p style="width: 15%; text-align: center; min-width: 40px;"><b>{{firma.firma}}</b></p>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </div>
    </b-overlay>
</template>

<script>
    import Vue from 'vue';

    import VueFileAgent from 'vue-file-agent';
    import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
    import axios from "@/axios";

    Vue.use(VueFileAgent);

    export default {
        data: function(){
            return {
                profilePic: {},
                fileLoaded: false,
                uploaded: false,
                uploadUrl: 'http://localhost:8000/api/documento/verificar-validez-documento',
                uploadHeaders: {},
                limite_peso_archivo: 50000000, //1 MB
                dataFile: '',
                message: '',
                typeMessage: '',
                iconMessage: '',
                info_verificacion: null,
                filename: '',
                tipo_firma_electronica: 'E',
                tipo_firma_digital: 'D',
                tipo_firma_simple: 'S',
                mostrarLoader: false
            }
        },

        methods:{
            removePic(){
                var profilePic = this.profilePic;
                this.$refs.profilePicRef.deleteUpload(this.uploadUrl, this.uploadHeaders, [profilePic]);
                this.profilePic = {};
                this.uploaded = false;
                this.cleanResultados()
            },

            upload(){
                this.enviarArchivoAVerificacion()

                // var self = this;
                // this.$refs.profilePicRef.upload(this.uploadUrl, this.uploadHeaders, [this.profilePic]).then(function(){
                //     self.uploaded = true;
                //     setTimeout(function(){
                //       self.profilePic.progress(0);
                //     }, 500);
                // });
            },

            onSelect(fileRecords){
                this.cleanResultados()
                this.uploaded = true;

                if(this.verificarMaxsize(this.profilePic.size) && this.checkFileExt(this.profilePic.ext)){
                    var file = this.profilePic.file
                    this.filename = this.profilePic.file.name
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    var that = this
                    reader.onload = function () {
                        that.dataFile = reader.result
                        that.upload()
                        // console.log(that.dataFile)
                    };
                }
                else{
                    this.removePic()
                }
            },

            verificarMaxsize(fileSize){
                if(fileSize>this.limite_peso_archivo){
                    this.$swal({
                      title: 'Error!',
                      text: 'El archivo es demasiado grande. El archivo no debe pesar más de 1 MB.',
                      icon: 'error',
                      customClass: {
                        confirmButton: 'btn btn-primary',
                      },
                      buttonsStyling: false,
                      confirmButtonText: 'Aceptar',
                    })
                    return false;
                }else{
                    return true;
                }
            },

            checkFileExt(fileExt){
                if(fileExt!='pdf' && fileExt!='PDF'){
                    this.$swal({
                      title: 'Error!',
                      text: 'Archivo no permitido. Elija un archivo PDF.',
                      icon: 'error',
                      customClass: {
                        confirmButton: 'btn btn-primary',
                      },
                      buttonsStyling: false,
                      confirmButtonText: 'Aceptar',
                    })
                    return false
                }
                return true
            },

            enviarArchivoAVerificacion(){
                this.openLoadingInDiv()
                var endpoint = ''

                if(this.$route.params.token){
                    endpoint = 'api/documento/verificar-validez-documento-con-token/'
                }
                else {
                    endpoint = 'api/documento/verificar-validez-documento/'
                }

                axios.post(endpoint, {
                    // tipo: 'E',
                    data: this.dataFile,
                    token_documento: this.$route.params.token
                }).then(response => {
                    // console.log(response.data)
                    this.message = response.data.message
                    this.info_verificacion = response.data.data

                    if ("error" === response.data.status) {
                        this.typeMessage = 'danger'
                        this.iconMessage = 'XCircleIcon'
                    } else {
                        this.typeMessage = 'success'
                        this.iconMessage = 'CheckCircleIcon'
                    }
                    this.closeLoadingInDiv()
                });
            },

            cleanResultados(){
                this.message = ''
                this.dataFile = ''
                this.typeMessage = ''
                this.controles = []
            },

            openLoadingInDiv(){
                this.mostrarLoader = true
            },
            closeLoadingInDiv(){
                this.mostrarLoader = false
            },
        }
    }
</script>

<style>
    #profile-pic-demo{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #profile-pic-demo .drop-help-text {
        display: none;
    }
    #profile-pic-demo .is-drag-over .drop-help-text {
        display: block;
    }
    #profile-pic-demo .profile-pic-upload-block {
        border: 2px dashed transparent;
        padding: 20px;
        padding-top: 0;
    }

    #profile-pic-demo .is-drag-over.profile-pic-upload-block {
        border-color: #AAA;
    }
    #profile-pic-demo .vue-file-agent {
        width: 180px;
        /*float: left;*/
        margin: 0 15px 5px 0;
        border: 0;
        box-shadow: none;
    }

    .resultados-list-container{
        overflow-x: auto;
    }
</style>
